import {
  styled,
  type TokenTextColor,
} from '@volkswagen-onehub/components-core';

interface StyleButtonIconProps {
  iconColor?: TokenTextColor;
  iconFill?: TokenTextColor;
  raised?: boolean;
}

export const StyledButtonIcon = styled.button<StyleButtonIconProps>(
  ({ raised, iconColor, iconFill, theme }) => `
  ${raised ? `box-shadow: 0px 0px 15px 0px #00000040;` : ''}
  padding: ${theme.size.static150};
  border-radius: 50%;
  background: ${theme.colors.background.primary};
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  display: flex;
  

  > * {
    ${iconColor ? `color: ${theme.colors.content.primary};` : ''}
  }

  > svg {
    ${iconFill ? `fill: ${theme.colors.content.primary};` : ''}
  }
`
);
